import { ConcreteEncodable } from "./ConcreteEncodable";

import { FwdRollChangeImplEncoder } from "../../encoder/FwdRollChangeImplEncoder";

import * as CubiqTS from "../../index";
import { FwdRollChange } from "../FwdRollChange";

export class FwdRollChangeImpl extends ConcreteEncodable implements FwdRollChange {
  public static enType: string = "com.bcdfx.model.fwdroll.FwdRollChangeImpl";

  /*FID=1*/
  public rowId: string;
  /*FID=2*/
  public rowType: CubiqTS.FwdRollRowType;
  /*FID=3*/
  public marketForwardPts: CubiqTS.BigNumber | null = null;
  /*FID=4*/
  public fwdMarkup: CubiqTS.BigNumber | null = null;
  /*FID=5*/
  public lockedForUserPricing: boolean;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = FwdRollChangeImplEncoder.Instance;
    this.setEncodableType(FwdRollChangeImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "FwdRollChangeImpl[" +
      "rowId=" +
      this.rowId +
      "rowType=" +
      this.rowType +
      "marketForwardPts=" +
      this.marketForwardPts +
      "fwdMarkup=" +
      this.fwdMarkup +
      "lockedForUserPricing=" +
      this.lockedForUserPricing +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
